import React, { useState, useEffect } from "react";
import useScrollReveal from "../hooks/useScrollReveal";
import "../../styles/pages/contact.css";
import "../../styles/module/contact-form.css";

import bg2 from "../../assets/images/img/bg-2.webp";
import arrow from "../../assets/images/img/downarrow.webp";
import bg5 from "../../assets/images/img/bg-5.webp";
import add from "../../assets/images/icons/address.svg";
import call from "../../assets/images/icons/call.svg";
import mail from "../../assets/images/icons/mail.svg";
import Clients from "../module/Clients";

export default function Contact() {
  useScrollReveal("slide-from-left");
  useScrollReveal("slide-from-right");
  useScrollReveal("drop-from-top");
  const [formStatus, setFormStatus] = useState({ type: "", message: "" });
  const [formValues, setFormValues] = useState({
    fullname: "",
    email: "",
    tel: "",
    message: "",
  });

  const [formErrors, setFormErrors] = useState({
    fullname: "",
    email: "",
    tel: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    let errors = { ...formErrors };
    let values = { ...formValues };

    values[name] = value;

    // Full Name
    if (name === "fullname") {
      errors.fullname = value.trim() === "" ? "Name is required" : "";
    }

    // Email
    if (name === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      errors.email = emailRegex.test(value)
        ? ""
        : "Please enter a valid email address";
    }

    // Nepali Mobile
    if (name === "tel") {
      const phone = value.replace(/[^0-9]/g, "");
      values.tel = phone;

      const nepaliPhoneRegex = /^(97|98)[0-9]{8}$/;

      if (phone.length < 10) {
        errors.tel = "Mobile number must be 10 digits";
      } else if (!nepaliPhoneRegex.test(phone)) {
        errors.tel = "Enter a valid Nepali mobile number";
      } else {
        errors.tel = "";
      }
    }

    // Message
    if (name === "message") {
      errors.message = value.trim() === "" ? "Message is required" : "";
    }

    setFormValues(values);
    setFormErrors(errors);
  };

  const handleSubmit = async (e, formId) => {
    e.preventDefault();
    const hasErrors = Object.values(formErrors).some((err) => err !== "");
    const hasEmpty = Object.values(formValues).some((val) => val.trim() === "");

    if (hasErrors || hasEmpty) {
      setFormStatus({
        type: "error",
        message: "Please fix the errors before submitting.",
      });
      return;
    }

    const form = document.getElementById(formId);
    const formData = new FormData(form);

    try {
      const res = await fetch("/mail/contact.php", {
        method: "POST",
        body: formData,
      });

      const data = await res.json();

      if (data.status === "success") {
        setFormStatus({ type: "success", message: data.message });
        form.reset();
      } else {
        setFormStatus({ type: "error", message: data.message });
      }
    } catch (err) {
      console.error("Error:", err);
      setFormStatus({
        type: "error",
        message: "Something went wrong. Please try again.",
      });
    }
  };

  useEffect(() => {
    if (formStatus.message) {
      const timer = setTimeout(() => {
        setFormStatus({ type: "", message: "" });
      }, 5000); // 5 seconds

      return () => clearTimeout(timer);
    }
  }, [formStatus.message]);

  return (
    <>
      <div className="main-wrapper">
        <img
          alt="scrollDown"
          src={bg2}
          className="landing__image-background-2 image-background slide-from-left"
        />
        <div
          className="rotated-text"
          onClick={() => (window.location.href = "#scroll")}
        >
          <img src={arrow} alt="downarrow" />
          <h4> scroll down</h4>
        </div>
        <div className="section section__contact">
          <div className="container">
            <div className="info slide-from-left">
              <h1>Here to help!</h1>
              <p className="contact-text">
                Have questions or interested in our offer? Contact us for
                precise answers and a customized solution.
              </p>
              <h6>Contact</h6>
              <div className="address">
                <img loading="lazy" width="19px" src={add} alt="address-icon" />
                <p className="address navigate-to-us">
                  Koteshwor,&nbsp;
                  <br />
                  Kathmandu, Nepal
                </p>
              </div>
              <div className="phone">
                <img loading="lazy" width="19px" src={call} alt="call-icon" />
                <a
                  id="contactButton4FbConversionTracker"
                  className="phone-clickable"
                  href="tel:+9779762688171"
                >
                  <p className="phone">+977-9762688171</p>
                </a>
              </div>
              <div className="mail">
                <img loading="lazy" width="22px" src={mail} alt="mail-icon" />
                <a
                  id="contactButton5FbConversionTracker"
                  href="mailto:info@genvixtech.com"
                >
                  <p className="mail">info@genvixtech.com</p>
                </a>
              </div>
            </div>
            <div className="map-mobile drop-from-top">
              <div id="map2">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14133.189972778866!2d85.33402186369541!3d27.677198771748124!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39eb19f2804a02bf%3A0x85468199859b2d8d!2sKoteshwor%2C%20Kathmandu%2C%20Bagmati%20Province%2044600!5e0!3m2!1sen!2snp!4v1788780742323!5m2!1sen!2snp"
                  width="100%"
                  height="596"
                  style={{ border: "0" }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="map"
                ></iframe>
              </div>
            </div>
            <div className="content">
              <div className="logo-gradient logo__contact"></div>
              <img
                loading="lazy"
                className="container-bg image-background slide-from-right"
                src={bg5}
                alt="container background"
              />
              <form
                id="contactForm"
                method="post"
                onSubmit={(e) => handleSubmit(e, "contactForm")}
                className="slide-from-right"
              >
                <div className="field">
                  <input
                    required
                    type="text"
                    name="fullname"
                    value={formValues.fullname}
                    onChange={handleChange}
                    placeholder="Name and surname *"
                  />
                  <label htmlFor="fullname">Name and surname *</label>
                </div>
                {formErrors.fullname && <p className="error-message">{formErrors.fullname}</p>}
                <div className="field">
                  <input
                    required
                    type="email"
                    name="email"
                    value={formValues.email}
                    onChange={handleChange}
                    placeholder="Email *"
                  />
                  <label htmlFor="email">Email *</label>
                </div>
                {formErrors.email && <p className="error-message">{formErrors.email}</p>}
                <div className="field">
                  <input
                    required
                    type="tel"
                    name="tel"
                    maxLength="10"
                    value={formValues.tel}
                    onChange={handleChange}
                    placeholder="Phone number *"
                  />
                  <label htmlFor="tel">Phone number *</label>
                </div>
                {formErrors.tel && <p className="error-message">{formErrors.tel}</p>}
                <div className="field">
                  <textarea
                    required
                    rows="3"
                    name="message"
                    value={formValues.message}
                    onChange={handleChange}
                    placeholder="Message content *"
                  />
                  <label htmlFor="message">Message content *</label>
                </div>
                {formErrors.message && (
                  <p className="error-message">{formErrors.message}</p>
                )}
                {formStatus.message && (
                  <p
                    className={`success-message${formStatus.message ? " sent" : ""
                      }`}
                  >
                    {formStatus.message}
                  </p>
                )}
                <button
                  type="submit"
                  className="btn blue"
                  name="main_form_submit"
                  value="Send Message"
                  disabled={
                    Object.values(formErrors).some((err) => err) ||
                    Object.values(formValues).some((val) => !val.trim())
                  }
                >
                  Send a message
                </button>
              </form>
            </div>
          </div>
          <div className="mobile-form">
            <div className="logo-gradient logo__contact"></div>
            <img
              loading="lazy"
              className="container-bg image-background slide-from-right"
              src={bg5}
              alt="container background"
            />
            <form
              id="contactFormMobile"
              method="post"
              onSubmit={(e) => handleSubmit(e, "contactFormMobile")}
              className="slide-from-right"
            >
              <div className="field">
                <input
                  required
                  type="text"
                  name="fullname"
                  id="fullname"
                  value={formValues.fullname}
                  onChange={handleChange}
                  placeholder="Name and surname *"
                />
                <label htmlFor="fullname">Name and surname *</label>
                {formErrors.fullname && <p className="error-message">{formErrors.fullname}</p>}
              </div>
              <div className="field">
                <input
                  required
                  type="email"
                  name="email"
                  id="email"
                  placeholder="Email *"
                  value={formValues.email}
                  onChange={handleChange}
                />
                <label htmlFor="email">Email *</label>
              </div>
              {formErrors.email && <p className="error-message">{formErrors.email}</p>}
              <div className="field">
                <input
                  required
                  type="tel"
                  name="tel"
                  id="tel"
                  placeholder="Phone number *"
                  maxLength="10"
                  value={formValues.tel}
                  onChange={handleChange}
                />
                <label htmlFor="tel">Phone number *</label>
              </div>
              {formErrors.tel && <p className="error-message">{formErrors.tel}</p>}
              <div className="field">
                <textarea
                  required
                  rows="3"
                  name="message"
                  id="message"
                  placeholder="Message content *"
                  value={formValues.message}
                  onChange={handleChange}
                />
                <label htmlFor="message">Message content *</label>
              </div>
              {formErrors.message && (
                <p className="error-message">{formErrors.message}</p>
              )}
              {formStatus.message && (
                <p
                  className={`success-message${formStatus.message ? " sent" : ""
                    }`}
                >
                  {formStatus.message}
                </p>
              )}
              <button
                type="submit"
                className="btn blue"
                name="main_form_submit"
                value="Send Message"
                disabled={
                  Object.values(formErrors).some((err) => err) ||
                  Object.values(formValues).some((val) => !val.trim())
                }
              >
                Send a message
              </button>
            </form>
          </div>
          <div id="scroll" className="container container__map drop-from-top">
            <div className="map">
              <div
                id="map"
                style={{ position: "relative", overflow: "hidden" }}
              >
                <div
                  style={{
                    height: "100%",
                    width: "100%",
                    position: "absolute",
                    top: 0,
                    left: 0,
                    backgroundColor: "rgb(229, 227, 223)",
                  }}
                >
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14133.189972778866!2d85.33402186369541!3d27.677198771748124!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39eb19f2804a02bf%3A0x85468199859b2d8d!2sKoteshwor%2C%20Kathmandu%2C%20Bagmati%20Province%2044600!5e0!3m2!1sen!2snp!4v1788780742323!5m2!1sen!2snp"
                    width="994"
                    height="500"
                    style={{ border: "0" }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="map"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Clients />
      </div>
    </>
  );
}
